import { today } from "@internationalized/date";
import { useDateFormatter } from "@react-aria/i18n";
import { useMutation } from "@tanstack/react-query";

import { useTRPC } from "@/integrations/trpc/react";
import { getDefaultTimeZone } from "@/lib/dates";

import { useAppForm } from "../../base/form";

export function DeleteScheduleForm() {
  const trpc = useTRPC();
  const { mutate } = useMutation(
    trpc.tournaments.deleteSchedule.mutationOptions(),
  );

  const form = useAppForm({
    defaultValues: {
      startDate: today(getDefaultTimeZone())
        .set({ month: 1, day: 1 })
        .add({ years: 1 }),
      endDate: today(getDefaultTimeZone())
        .set({ month: 12, day: 31 })
        .add({ years: 1 }),
    },
    onSubmit: ({ value: { startDate, endDate } }) => {
      mutate({
        startDate: startDate.toString(),
        endDate: endDate.toString(),
      });
    },
  });

  const dateFormatter = useDateFormatter({
    dateStyle: "short",
    timeZone: getDefaultTimeZone(),
  });

  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={(e) => {
        e.preventDefault();

        form.handleSubmit();
      }}
    >
      <form.Alert
        color="warning"
        title={"Warning!"}
        description="You cannot undo this. However, you can copy a schedule again."
      />

      <form.AppField
        name="startDate"
        children={(field) => (
          <field.DatePicker
            label="Start Date"
            className="col-span-2"
            field={field}
          />
        )}
      />

      <form.AppField
        name="endDate"
        children={(field) => (
          <field.DatePicker
            label="End Date"
            className="col-span-2"
            field={field}
          />
        )}
      />

      <form.AppForm>
        <form.Footer>
          <form.ConfirmSubmitButton
            requireChange={false}
            description={
              <div className="space-y flex flex-col">
                <div className="flex flex-row space-x-2">
                  <span className="font-semibold">Start date:</span>
                  <span>
                    {dateFormatter.format(
                      form.state.values.startDate.toDate(getDefaultTimeZone()),
                    )}
                  </span>
                </div>
                <div className="flex flex-row space-x-2">
                  <span className="font-semibold">End date:</span>
                  <span>
                    {dateFormatter.format(
                      form.state.values.endDate.toDate(getDefaultTimeZone()),
                    )}
                  </span>
                </div>
              </div>
            }
          >
            Submit
          </form.ConfirmSubmitButton>
        </form.Footer>
      </form.AppForm>
    </form>
  );
}
